import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["xsm", "sm", "md", "lg", "xlg", "xxlg", "wd", "xwd", "at", "from", "until", "nojs", "print", "component", "tagName", "className", "children"];
import _Object$values from "@babel/runtime-corejs2/core-js/object/values";
import * as React from 'react';
import pick from 'lodash/pick';
import clsx from 'clsx';
var styles = {
  "all": "Hide-all_3co9V",
  "xsm": "Hide-xsm_f6bSR",
  "sm": "Hide-sm_1tyH4",
  "md": "Hide-md_hkOa8",
  "lg": "Hide-lg_2JRqy",
  "xlg": "Hide-xlg_3afZI",
  "xxlg": "Hide-xxlg_ca5wp",
  "wd": "Hide-wd_3D2DV",
  "xwd": "Hide-xwd_27Uis",
  "from-xsm": "Hide-from-xsm_3V2ry",
  "from-sm": "Hide-from-sm_K7cQm",
  "from-md": "Hide-from-md_3Zxuu",
  "from-lg": "Hide-from-lg_stK8F",
  "from-xlg": "Hide-from-xlg_qkEGr",
  "from-xxlg": "Hide-from-xxlg_7ijUe",
  "from-wd": "Hide-from-wd_2OHJF",
  "from-xwd": "Hide-from-xwd_3vaTS",
  "until-xsm": "Hide-until-xsm_ge1CD",
  "until-sm": "Hide-until-sm_1vxoe",
  "until-md": "Hide-until-md_BdHvw",
  "until-lg": "Hide-until-lg_1k7x7",
  "until-xlg": "Hide-until-xlg_1do7g",
  "until-xxlg": "Hide-until-xxlg_1eXl5",
  "until-wd": "Hide-until-wd_9lZki",
  "until-xwd": "Hide-until-xwd_1QT3u",
  "nojs": "Hide-nojs_1LmLa",
  "print": "Hide-print_2WojK"
};
function Hide(props) {
  var _clsx;
  var xsm = props.xsm,
    sm = props.sm,
    md = props.md,
    lg = props.lg,
    xlg = props.xlg,
    xxlg = props.xxlg,
    wd = props.wd,
    xwd = props.xwd,
    at = props.at,
    from = props.from,
    until = props.until,
    nojs = props.nojs,
    print = props.print,
    component = props.component,
    _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'span' : _props$tagName,
    className = props.className,
    children = props.children,
    extraProps = _objectWithoutProperties(props, _excluded);
  var hasBreapoint = _Object$values(pick(props, ['xsm', 'sm', 'md', 'lg', 'xlg', 'xxlg', 'wd', 'xwd', 'at', 'from', 'until', 'nojs', 'print'])).some(Boolean);
  var rootClasses = clsx((_clsx = {}, _defineProperty(_clsx, styles.all, !hasBreapoint), _defineProperty(_clsx, styles.xsm, xsm), _defineProperty(_clsx, styles.sm, sm), _defineProperty(_clsx, styles.md, md), _defineProperty(_clsx, styles.lg, lg), _defineProperty(_clsx, styles.xlg, xlg), _defineProperty(_clsx, styles.xxlg, xxlg), _defineProperty(_clsx, styles.wd, wd), _defineProperty(_clsx, styles.xwd, xwd), _defineProperty(_clsx, styles.nojs, nojs), _defineProperty(_clsx, styles.print, print), _clsx), at && styles[at], from && styles["from-".concat(from)], until && styles["until-".concat(until)], className);
  if (component && /*#__PURE__*/React.isValidElement(component)) {
    // $FlowFixMe[cannot-spread-inexact]
    return /*#__PURE__*/React.cloneElement(component, _objectSpread({
      className: clsx(component.props.className, rootClasses)
    }, extraProps));
  }
  if (typeof children === 'string') {
    return /*#__PURE__*/React.createElement(tagName, // $FlowFixMe[cannot-spread-inexact]
    _objectSpread({
      className: clsx(className, rootClasses)
    }, extraProps), children);
  }

  // Ensure null children filtering by converting to a true Array.
  return React.Children.toArray(children).map(function (child) {
    return /*#__PURE__*/React.isValidElement(child) ?
    /*#__PURE__*/
    // $FlowFixMe[incompatible-type]
    // $FlowFixMe[incompatible-exact]
    // $FlowFixMe[cannot-spread-inexact]
    React.cloneElement(child, _objectSpread({
      // $FlowFixMe[prop-missing]
      // $FlowFixMe[incompatible-use]
      className: clsx(child.props.className, rootClasses)
    }, extraProps)) : child;
  });
}
export default Hide;